import clsx from 'clsx'
import {
  Building2,
  Store,
  Briefcase,
  Factory,
  Hotel,
  HardHat,
  Mountain,
  Warehouse,
  GraduationCap,
  Heart,
} from 'lucide-react'
import type { AssetClass } from '@/types'
import { UNDERWRITING_ASSET_CLASSES } from '@/types/underwritingModels'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ICONS: Record<string, React.ComponentType<any>> = {
  Multifamily: Building2,
  Retail: Store,
  Office: Briefcase,
  Industrial: Factory,
  Hospitality: Hotel,
  'Senior Living': Heart,
  Construction: HardHat,
  Land: Mountain,
  'Self-Storage': Warehouse,
  'Student Housing': GraduationCap,
}

interface Props {
  /** Null when no model applies to the deal until a person chooses one. */
  selected: AssetClass | null
  onSelect: (ac: AssetClass) => void
}

export default function AssetClassSelector({ selected, onSelect }: Props) {
  return (
    <div className="flex items-center gap-1 rounded-lg border border-amber-400/10 bg-black/30 p-0.5">
      {UNDERWRITING_ASSET_CLASSES.map((ac) => {
        const Icon = ICONS[ac] ?? Building2
        const active = ac === selected
        return (
          <button
            key={ac}
            aria-pressed={active}
            onClick={() => onSelect(ac)}
            className={clsx(
              'flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[11px] font-medium transition-all duration-150',
              active
                ? 'bg-amber-400/15 text-amber-200 border border-amber-400/25'
                : 'text-stone-500 hover:text-stone-300 hover:bg-white/[0.03] border border-transparent'
            )}
          >
            <Icon size={12} />
            {ac}
          </button>
        )
      })}
    </div>
  )
}
